/**
 * Encoding Presets API Client
 *
 * Frontend wrapper for encoding preset CRUD operations
 * Used for managing video/audio encoding settings for processing jobs
 */

import axios from '@/axios'

export default {
  /**
   * Get all encoding presets for current organization
   */
  async getAll() {
    try {
      const response = await axios.get('/api/encoding-presets')
      return response.data
    } catch (error) {
      console.error('Get encoding presets error:', error)
      throw error
    }
  },

  /**
   * Get single encoding preset by ID
   */
  async getById(id) {
    try {
      const response = await axios.get(`/api/encoding-presets/${id}`)
      return response.data
    } catch (error) {
      console.error('Get encoding preset error:', error)
      throw error
    }
  },

  /**
   * Get preset by code
   */
  async getByCode(code) {
    try {
      const response = await axios.get(`/api/encoding-presets/code/${code}`)
      return response.data
    } catch (error) {
      console.error('Get encoding preset by code error:', error)
      throw error
    }
  },

  /**
   * Get available options for preset fields (codecs, formats, etc.)
   */
  async getOptions() {
    try {
      const response = await axios.get('/api/encoding-presets/options')
      return response.data
    } catch (error) {
      console.error('Get preset options error:', error)
      throw error
    }
  },

  /**
   * Create new encoding preset
   */
  async create(data) {
    try {
      const response = await axios.post('/api/encoding-presets', data)
      return response.data
    } catch (error) {
      console.error('Create encoding preset error:', error)
      throw error
    }
  },

  /**
   * Update existing encoding preset
   */
  async update(id, data) {
    try {
      const response = await axios.put(`/api/encoding-presets/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Update encoding preset error:', error)
      throw error
    }
  },

  /**
   * Delete encoding preset
   */
  async delete(id) {
    try {
      const response = await axios.delete(`/api/encoding-presets/${id}`)
      return response.data
    } catch (error) {
      console.error('Delete encoding preset error:', error)
      throw error
    }
  },

  /**
   * Set a preset as the default for the organization
   */
  async setDefault(id) {
    try {
      const response = await axios.post(`/api/encoding-presets/${id}/set-default`)
      return response.data
    } catch (error) {
      console.error('Set default preset error:', error)
      throw error
    }
  },

  /**
   * Duplicate an existing preset
   */
  async duplicate(id, newName) {
    try {
      const response = await axios.post(`/api/encoding-presets/${id}/duplicate`, { new_name: newName })
      return response.data
    } catch (error) {
      console.error('Duplicate preset error:', error)
      throw error
    }
  }
}
